import { Component, OnInit, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { AinPageComponent } from '../../shared/design-system/page.component';
import { AccountingBasisRecord, FinanceApiService } from './finance-api.service';

@Component({
  standalone: true,
  selector: 'ain-finance-control-center-accounting-basis',
  imports: [AinPageComponent, FormsModule, TableModule, ButtonModule, InputTextModule, RouterLink],
  providers: [MessageService],
  template: `
    <ain-page title="Accounting Basis" description="Create and review accounting basis setup">
      <div class="toolbar">
        <a class="back-link" [routerLink]="['/financial/control-center']">Back to Control Center</a>
      </div>

      <div class="create-row">
        <input pInputText [(ngModel)]="basisCode" placeholder="Code" />
        <input pInputText [(ngModel)]="basisName" placeholder="Name" />
        <button pButton type="button" label="Create" (click)="createBasis()"></button>
      </div>

      <p-table [value]="rows()">
        <ng-template pTemplate="header">
          <tr>
            <th>Code</th>
            <th>Name</th>
            <th>System</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr>
            <td>{{ row.code }}</td>
            <td>{{ row.name }}</td>
            <td>{{ row.isSystem ? 'Yes' : 'No' }}</td>
          </tr>
        </ng-template>
      </p-table>
    </ain-page>
  `,
  styles: [`
    .toolbar { margin-bottom: 12px; }
    .back-link { color: var(--ain-color-primary); font-weight: 600; text-decoration: none; }
    .create-row { margin-bottom: 12px; display: flex; gap: 8px; flex-wrap: wrap; }
  `]
})
export class FinanceControlCenterAccountingBasisComponent implements OnInit {
  private readonly api = inject(FinanceApiService);
  private readonly messages = inject(MessageService);

  readonly rows = signal<AccountingBasisRecord[]>([]);
  basisCode = '';
  basisName = '';

  ngOnInit(): void {
    this.api.listAccountingBasis().subscribe({ next: result => this.rows.set(result) });
  }

  createBasis(): void {
    const code = this.basisCode.trim();
    const name = this.basisName.trim();
    if (!code || !name) {
      return;
    }

    this.api.createAccountingBasis({ code, name, isSystem: false }).subscribe({
      next: created => {
        this.rows.update(items => [created, ...items]);
        this.basisCode = '';
        this.basisName = '';
      },
      error: () => this.messages.add({ severity: 'error', summary: 'Accounting basis creation failed' })
    });
  }
}
